const useHelpers = () => {
  const getTime = (date?: Date) => {
    return date != null ? new Date(date).getTime() : 0;
  }

  return { getTime };
};

export default useHelpers;
